var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[(_vm.showError)?_c('message-card',{attrs:{"title":_vm.title,"message":_vm.message,"show-back-button":_vm.showBackButton,"show-login-button":_vm.showLoginButton}}):_c('loading-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }